/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class OptometryPendingService extends MainService {
  static optometryProcedures() {
    return this.postSEC(ServiceConstant.OPTOMETRY_PROCEDURES);
  }
  static optometryZones() {
    return this.postSEC(ServiceConstant.OPTOMETRY_ZONES);
  }
  static optometrySide() {
    return this.postSEC(ServiceConstant.OPTOMETRY_SIDE);
  }
  static optometryGlassesType() {
    return this.postSEC(ServiceConstant.OPTOMETRY_GLASSESTYPES);
  }
}
